import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faAngleUp,
  faArrowDown,
  faSave,
  faTimes,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import "react-tabs/style/react-tabs.css";
import apiUrl from "../../apiUrlConstant";
import { Redirect, withRouter, Link } from "react-router-dom";
import { getToDate } from "../../utils/utils";
import SimpleReactValidator from "simple-react-validator";
import { PopupMessage } from "../../utils/utils";
import moment from "moment";

const headers = {
  "Content-Type": "application/json",
  Authorization: "Bearer " + localStorage.getItem("TOKEN"),
};

class LockInNoticePeriod extends React.Component {
  state = {
    messsagePopup: false,
    popupContent: "Data Saved Successfully!",
    landlordLockInLeaseDate: "",
    landlordLockInRentDate: "",
    redirect: false,
    initialValues: {
      lockInPeriodOccupier: [],
    },
    lockInPeriodOccupier: [],
    lockInPeriodCount: 1,
    lockInPeriodLandlordStartDate: "",
    lockInPeriodLandlordMM: "",
    lockInPeriodLandlordDD: "",
    lockInPeriodLandlordYY: "",
    terminationNoticePeriodMM: "",
    terminationNoticePeriodDD: "",
    toggleLandlordForm: false,
    toggleOccupierForm: false,
    lockinPeriodLandlordEndDate: "",
    fullLockInPeriodFlag: false,
  };

  constructor(props) {
    super(props);
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
  }

  showLandlordForm = (e) => {
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value === "yes") {
      this.setState({
        toggleLandlordForm: true,
      });
    } else {
      this.setState({
        toggleLandlordForm: false,
      });
    }
  };

  showOccupierForm = (e) => {
    this.mainFormValidator = new SimpleReactValidator({
      autoForceUpdate: this,
    });
    if (e.target.value === "yes") {
      this.setState({
        toggleOccupierForm: true,
      });
    } else {
      this.setState({
        toggleOccupierForm: false,
      });
    }
  };

  componentDidMount() {
    fetch(`${apiUrl.apiUrl.url}/occupier-groups`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          occupierGroups: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    fetch(`${apiUrl.apiUrl.url}/countries`, { headers })
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          countries: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });

    let athis = this;
    axios({
      url: `${apiUrl.apiUrl.url}/create-lease/fetch-lease-lockin-form?id=${this.props.match.params.id}`,
      method: "GET",
    }).then(function(response){
      let data = response.data;
      console.log(data);
        if (data.lockInPeriodOccupier == null) {
          data.lockInPeriodOccupier = [{}];
        }
        if (data.lockInPeriodLandlordMM == 0) {
          athis.setState({ lockInPeriodLandlordMM: "" });
        } else {
          athis.setState({
            lockInPeriodLandlordMM: data.lockInPeriodLandlordMM,
          });
        }
        if (data.lockInPeriodLandlordYY == 0) {
          athis.setState({ lockInPeriodLandlordYY: "" });
        } else {
          athis.setState({
            lockInPeriodLandlordYY: data.lockInPeriodLandlordYY,
          });
        }
        if (data.lockInPeriodLandlordDD == 0) {
          athis.setState({ lockInPeriodLandlordDD: "" });
        } else {
          athis.setState({
            lockInPeriodLandlordDD: data.lockInPeriodLandlordDD,
          });
        }
        if (data.terminationNoticePeriodDD == 0) {
          athis.setState({ terminationNoticePeriodDD: "" });
        } else {
          athis.setState({
            terminationNoticePeriodDD: data.terminationNoticePeriodDD,
          });
        }
        if (data.terminationNoticePeriodMM == 0) {
          athis.setState({ terminationNoticePeriodMM: "" });
        } else {
          athis.setState({
            terminationNoticePeriodMM: data.terminationNoticePeriodMM,
          });
        }
        if (data.lockInApplicableForLandlord === "yes") {
          athis.setState({
            toggleLandlordForm: true,
          });
        } else {
          athis.setState({
            toggleLandlordForm: false,
          });
        }
        if (data.lockInApplicableForOccupier === "yes") {
          athis.setState({
            toggleOccupierForm: true,
          });
        } else {
          athis.setState({
            toggleOccupierForm: false,
          });
        }



        // for (let i = 0; i < data.lockInPeriodOccupier.length; i++) {
        //   console.log(athis.state.lockInPeriodOccupier);
        //   if (data.lockInPeriodOccupier[i].lockInPeriodDD == 0) {
        //     athis.state.lockInPeriodOccupier[i].lockInPeriodDD = "";
        //   } else {
        //     athis.state.lockInPeriodOccupier[i].lockInPeriodDD =
        //       data.lockInPeriodOccupier[i].lockInPeriodDD;
        //   }
        //   if (data.lockInPeriodOccupier[i].lockInPeriodMM == 0) {
        //     athis.state.lockInPeriodOccupier[i].lockInPeriodMM = "";
        //   } else {
        //     athis.state.lockInPeriodOccupier[i].lockInPeriodMM =
        //       data.lockInPeriodOccupier[i].lockInPeriodMM;
        //   }
        // }
        athis.setState({
          initialValues: data,
          lockInPeriodOccupier: data.lockInPeriodOccupier,
          lockInPeriodCount: data.lockInPeriodOccupier.length > 0 ? data.lockInPeriodOccupier.length : 1,
          landlordLockInLeaseDate: data.leaseCommencementDate,
          landlordLockInRentDate: data.rentCommencementDate,
          landlordLockInRenewalDate: data.renewalCommencementDate,
          lockinPeriodLandlordEndDate: data.leaseExpiryDate
        });


        if (data.leaseExpiryDate == data.lockInPeriodLandlordEndDate) {
          athis.setState({
            fullLockInPeriodFlag: true,
          });

          athis.getDateDiff(data.lockInPeriodLandlordStartDate);
        }
    });  

    // fetch(
    //   `${apiUrl.apiUrl.url}/create-lease/fetch-lease-lockin-form?id=${this.props.match.params.id}`
    // )
    //   .then((response) => {
    //     return response.json();
    //   })
    //   .then((data) => {
    //     console.log(data);
    //     if (data.lockInPeriodOccupier == null) {
    //       data.lockInPeriodOccupier = [{}];
    //     }
    //     if (data.lockInPeriodLandlordMM == 0) {
    //       this.setState({ lockInPeriodLandlordMM: "" });
    //     } else {
    //       this.setState({
    //         lockInPeriodLandlordMM: data.lockInPeriodLandlordMM,
    //       });
    //     }
    //     if (data.lockInPeriodLandlordYY == 0) {
    //       this.setState({ lockInPeriodLandlordYY: "" });
    //     } else {
    //       this.setState({
    //         lockInPeriodLandlordYY: data.lockInPeriodLandlordYY,
    //       });
    //     }
    //     if (data.lockInPeriodLandlordDD == 0) {
    //       this.setState({ lockInPeriodLandlordDD: "" });
    //     } else {
    //       this.setState({
    //         lockInPeriodLandlordDD: data.lockInPeriodLandlordDD,
    //       });
    //     }
    //     if (data.terminationNoticePeriodDD == 0) {
    //       this.setState({ terminationNoticePeriodDD: "" });
    //     } else {
    //       this.setState({
    //         terminationNoticePeriodDD: data.terminationNoticePeriodDD,
    //       });
    //     }
    //     if (data.terminationNoticePeriodMM == 0) {
    //       this.setState({ terminationNoticePeriodMM: "" });
    //     } else {
    //       this.setState({
    //         terminationNoticePeriodMM: data.terminationNoticePeriodMM,
    //       });
    //     }
    //     if (data.lockInApplicableForLandlord === "yes") {
    //       this.setState({
    //         toggleLandlordForm: true,
    //       });
    //     } else {
    //       this.setState({
    //         toggleLandlordForm: false,
    //       });
    //     }
    //     if (data.lockInApplicableForOccupier === "yes") {
    //       this.setState({
    //         toggleOccupierForm: true,
    //       });
    //     } else {
    //       this.setState({
    //         toggleOccupierForm: false,
    //       });
    //     }



    //     // for (let i = 0; i < data.lockInPeriodOccupier.length; i++) {
    //     //   console.log(this.state.lockInPeriodOccupier);
    //     //   if (data.lockInPeriodOccupier[i].lockInPeriodDD == 0) {
    //     //     this.state.lockInPeriodOccupier[i].lockInPeriodDD = "";
    //     //   } else {
    //     //     this.state.lockInPeriodOccupier[i].lockInPeriodDD =
    //     //       data.lockInPeriodOccupier[i].lockInPeriodDD;
    //     //   }
    //     //   if (data.lockInPeriodOccupier[i].lockInPeriodMM == 0) {
    //     //     this.state.lockInPeriodOccupier[i].lockInPeriodMM = "";
    //     //   } else {
    //     //     this.state.lockInPeriodOccupier[i].lockInPeriodMM =
    //     //       data.lockInPeriodOccupier[i].lockInPeriodMM;
    //     //   }
    //     // }
    //     this.setState({
    //       initialValues: data,
    //       lockInPeriodOccupier: data.lockInPeriodOccupier,
    //       lockInPeriodCount: data.lockInPeriodOccupier.length > 0 ? data.lockInPeriodOccupier.length : 1,
    //       landlordLockInLeaseDate: data.leaseCommencementDate,
    //       landlordLockInRentDate: data.rentCommencementDate,
    //       landlordLockInRenewalDate: data.renewalCommencementDate,
    //       lockinPeriodLandlordEndDate: data.leaseExpiryDate
    //     });


    //     if (data.leaseExpiryDate == data.lockInPeriodLandlordEndDate) {
    //       this.setState({
    //         fullLockInPeriodFlag: true,
    //       });

    //       this.getDateDiff(data.lockInPeriodLandlordStartDate);
    //     }

    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });
  }
  changeOccupier = (e) => {
    let groupid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/occupier/get-group-companies/?id=` + groupid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          companyName: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  changeCountry = (e) => {
    let countryid = e.target.value;
    fetch(`${apiUrl.apiUrl.url}/states/country-states/` + countryid, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({
          states: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  changeState = (e) => {
    let stateId = e.target.value;
    console.log(stateId, "SI");
    fetch(`${apiUrl.apiUrl.url}/cities/state-cities/` + stateId, {headers})
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data, "data");
        this.setState({
          cities: data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  calculateLockInEndDate(e, values) {
    console.log(values);
    values.lockInPeriodLandlordEndDate = getToDate(
      values.lockInPeriodLandlordStartDate,
      Number(this.state.lockInPeriodLandlordDD),
      Number(this.state.lockInPeriodLandlordMM),
      Number(this.state.lockInPeriodLandlordYY),
    );
    this.setState({});
  }

  getDateDiff = (startDate) => {
    var a = moment(this.state.lockinPeriodLandlordEndDate);
    var b = moment(startDate);
    console.log(startDate + ' ' + this.state.lockinPeriodLandlordEndDate);
    var years = a.diff(b, "year");
    b.add(years, "years");
    var months = a.diff(b, "months");
    b.add(months, "months");
    var days = a.diff(b, "days");
    this.setState({
      lockInPeriodLandlordYY: years,
      lockInPeriodLandlordMM: months,
      lockInPeriodLandlordDD: Number(days) + 1,
    });
  };

  calculateOccupierLockInEndDate(values) {
    for (let i = 0; i < values.lockInPeriodOccupier.length; i++) {
      if (isNaN(values.lockInPeriodOccupier[i].lockInPeriodDD)) {
        values.lockInPeriodOccupier[i].lockInPeriodDD = "";
      }
      if (isNaN(values.lockInPeriodOccupier[i].lockInPeriodMM)) {
        values.lockInPeriodOccupier[i].lockInPeriodMM = "";
      }
      if (isNaN(values.lockInPeriodOccupier[i].lockInPeriodYY)) {
        values.lockInPeriodOccupier[i].lockInPeriodYY = "";
      }
      values.lockInPeriodOccupier[i].lockInEndDate = getToDate(
        values.lockInPeriodOccupier[i].lockInFromDate,
        Number(values.lockInPeriodOccupier[i].lockInPeriodDD),
        Number(values.lockInPeriodOccupier[i].lockInPeriodMM),
        Number(values.lockInPeriodOccupier[i].lockInPeriodYY),
      );
      this.setState({});
    }
  }

  changeLockInPeriodLandlord(e, values) {
    console.log("here", e.target.value)
    if (e.target.value == "") {
      this.state.lockInPeriodLandlordDD = "";
      this.state.lockInPeriodLandlordMM = "";
      this.state.lockInPeriodLandlordYY = "";
    }
    console.log(values);
    if (e.target.value == "Lease Commencement Date") {
      values.lockInPeriodLandlordStartDate = this.state.landlordLockInLeaseDate;
    } else if (e.target.value == "Rent Commencement Date") {
      values.lockInPeriodLandlordStartDate = this.state.landlordLockInRentDate;
    }else if (e.target.value == "Renewal Commencement Date") {
      values.lockInPeriodLandlordStartDate = this.state.landlordLockInRenewalDate;
    }

    console.log(values.lockInPeriodLandlordStartDate, "values.lockInPeriodLandlordStartDate", this.state.landlordLockInRenewalDate)

    values.lockInPeriodLandlordEndDate = getToDate(
      values.lockInPeriodLandlordStartDate,
      Number(this.state.lockInPeriodLandlordDD),
      Number(this.state.lockInPeriodLandlordMM),
      Number(this.state.lockInPeriodLandlordYY),
    );
    this.setState({});
  }

  changeLockInPeriodOccupier(values, id) {
    for (let i = 0; i < values.lockInPeriodOccupier.length; i++) {
      if (
        values.lockInPeriodOccupier[i].lockInPeriod == "Lease Commencement Date"
      ) {
        values.lockInPeriodOccupier[i].lockInFromDate =
          this.state.landlordLockInLeaseDate;
      } else if (
        values.lockInPeriodOccupier[i].lockInPeriod == "Rent Commencement Date"
      ) {
        values.lockInPeriodOccupier[i].lockInFromDate =
          this.state.landlordLockInRentDate;
      } else if (
        values.lockInPeriodOccupier[i].lockInPeriod == "Renewal Commencement Date"
      ) {
        values.lockInPeriodOccupier[i].lockInFromDate =
          this.state.landlordLockInRenewalDate;
      }
      values.lockInPeriodOccupier[i].lockInEndDate = getToDate(
        values.lockInPeriodOccupier[i].lockInFromDate,
        Number(values.lockInPeriodOccupier[i].lockInPeriodDD),
        Number(values.lockInPeriodOccupier[i].lockInPeriodMM),
        Number(values.lockInPeriodOccupier[i].lockInPeriodYY),
      );
      this.setState({});
    }
  }

  redirectAfterSave = () => {
    this.setState({ redirect: true });
  };

  handleDelete = (index) => {
    // Create a copy of the landlords array
    let _occupiers = [...this.state.lockInPeriodOccupier];

    // Remove the item at the specified index
    _occupiers.splice(index, 1);

    // Update the state
    this.setState({
      lockInPeriodOccupier: _occupiers,
      lockInPeriodCount: this.state.lockInPeriodCount - 1
    });
  }

  lockInPeriodTabs(handleChange, values) {
    var heads = [];
    for (var i = 0; i < this.state.lockInPeriodCount; i++) {
      heads.push(<Tab>Lock In Period {i + 1} {heads.length < 1 ? null : <span onClick={() => this.handleDelete(i)} className="ms-2"><FontAwesomeIcon icon={faTimes} /></span>}</Tab>);
    }

    var body = [];
    for (var i = 0; i < this.state.lockInPeriodCount; i++) {
      if (
        typeof this.state.lockInPeriodOccupier[i] === "undefined" ||
        this.state.lockInPeriodOccupier[i] === null
      ) {
        this.state.lockInPeriodOccupier[i] = {};
        this.state.lockInPeriodOccupier[i].lockInPeriod = "";
        this.state.lockInPeriodOccupier[i].lockInPeriodYY = "";
        this.state.lockInPeriodOccupier[i].lockInPeriodMM = "";
        this.state.lockInPeriodOccupier[i].lockInPeriodDD = "";
        this.state.lockInPeriodOccupier[i].lockInFromDate = "";
        this.state.lockInPeriodOccupier[i].lockInEndDate = "";
        values.lockInPeriodOccupier[i] = {};
        values.lockInPeriodOccupier[i].lockInPeriod = "";
        values.lockInPeriodOccupier[i].lockInPeriodYY = "";
        values.lockInPeriodOccupier[i].lockInPeriodMM = "";
        values.lockInPeriodOccupier[i].lockInPeriodDD = "";
        values.lockInPeriodOccupier[i].lockInFromDate = "";
        values.lockInPeriodOccupier[i].lockInEndDate = "";
      }
      body.push(
        <TabPanel>
          <div className="unitFormContainerNew">
            <div className="newGridSectionParent p-0">
              <div className="newGridSectionForFormMain align-items-start">
                <div className="newGridSectionInner">
                  <label>
                    Lock In Period For Occupier (MM-DD) Effective From
                    <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <div className="row m-0 mt-3">
                      <div className="col-12 p-0 mb-2">
                        <select
                          param={i}
                          name={"lockInPeriodOccupier[" + i + "].lockInPeriod"}
                          value={this.state.lockInPeriodOccupier[i].lockInPeriod}
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.state.lockInPeriodOccupier[id].lockInPeriod =
                              e.target.value;
                            this.calculateOccupierLockInEndDate(values);
                            this.changeLockInPeriodOccupier(values, id);
                            handleChange(e);
                          }}
                        >
                          <option value="" label="Select" defaultValue />
                          <option
                            value="Lease Commencement Date"
                            label="Lease Commencement Date"
                          />
                          <option
                            value="Rent Commencement Date"
                            label="Rent Commencement Date"
                          />
                          <option
                            value="Renewal Commencement Date"
                            label="Renewal Commencement Date"
                          />
                          <option value="other" label="Other" />
                        </select>
                      </div>
                      <div className="col-sm-4 p-0">
                        <Field
                          type="text"
                          param={i}
                          name={"lockInPeriodOccupier[" + i + "].lockInPeriodYY"}
                          value={
                            this.state.lockInPeriodOccupier[i].lockInPeriodYY
                          }
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.state.lockInPeriodOccupier[id].lockInPeriodYY =
                              e.target.value;
                            this.calculateOccupierLockInEndDate(values);
                            handleChange(e);
                          }}
                          onBlur={(e) => {
                            this.calculateOccupierLockInEndDate(values);
                          }}
                          placeholder="YY"
                          className="centerPlaceHolder"
                        />
                      </div>
                      <div className="col-sm-4">
                        <Field
                          type="text"
                          param={i}
                          name={"lockInPeriodOccupier[" + i + "].lockInPeriodMM"}
                          value={
                            this.state.lockInPeriodOccupier[i].lockInPeriodMM
                          }
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.state.lockInPeriodOccupier[id].lockInPeriodMM =
                              e.target.value;
                            this.calculateOccupierLockInEndDate(values);
                            handleChange(e);
                          }}
                          onBlur={(e) => {
                            this.calculateOccupierLockInEndDate(values);
                          }}
                          placeholder="MM"
                          className="centerPlaceHolder"
                        />
                      </div>
                      <div className="col-sm-4 p-0">
                        <Field
                          type="text"
                          param={i}
                          name={"lockInPeriodOccupier[" + i + "].lockInPeriodDD"}
                          value={
                            this.state.lockInPeriodOccupier[i].lockInPeriodDD
                          }
                          onChange={(e) => {
                            var id = e.target.getAttribute("param");
                            this.state.lockInPeriodOccupier[id].lockInPeriodDD =
                              e.target.value;
                            this.calculateOccupierLockInEndDate(values);
                            handleChange(e);
                          }}
                          onBlur={(e) => {
                            this.calculateOccupierLockInEndDate(values);
                          }}
                          placeholder="DD"
                          className="centerPlaceHolder"
                        />
                      </div>
                    </div>
                    {this.mainFormValidator.message(
                      "Lock In Period For Occupier",
                      this.state.lockInPeriodOccupier[i].lockInPeriod,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>
                </div>
                <div className="newGridSectionInner"></div>
                <div className="newGridSectionInner">
                  <label>
                    Lock In From Date (For Occupier)
                    <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <Field
                      type="date"
                      param={i}
                      name={"lockInPeriodOccupier[" + i + "].lockInFromDate"}
                      value={
                        this.state.lockInPeriodOccupier[i].lockInFromDate
                      }
                      onChange={(e) => {
                        var id = e.target.getAttribute("param");
                        this.state.lockInPeriodOccupier[id].lockInFromDate =
                          e.target.value;
                        handleChange(e);
                      }}
                    />
                    {this.mainFormValidator.message(
                      "Lock In From Date For Occupier",
                      this.state.lockInPeriodOccupier[i].lockInFromDate,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>
                </div>
                <div className="newGridSectionInner">
                  <label>
                    Lock In End Date (For Occupier)
                    <span className="astrik">*</span>
                  </label>
                  <div className="position-relative">
                    <Field
                      type="date"
                      param={i}
                      name={"lockInPeriodOccupier[" + i + "].lockInEndDate"}
                      value={this.state.lockInPeriodOccupier[i].lockInEndDate}
                      onChange={(e) => {
                        var id = e.target.getAttribute("param");
                        this.state.lockInPeriodOccupier[id].lockInEndDate =
                          e.target.value;
                        handleChange(e);
                      }}
                    />
                    {this.mainFormValidator.message(
                      "Lock In End Date For Occupier",
                      this.state.lockInPeriodOccupier[i].lockInEndDate,
                      "required",
                      { className: "text-danger" }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="tabHolder">
            <div className="row tabForm">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row">
                    <label className="col-sm-4 col-form-label">
                      Lock In Period For Occupier (MM-DD) Effective From
                      <span className="astrik">*</span>
                    </label>
                    <div className="col-sm-8">
                      <select
                        param={i}
                        name={"lockInPeriodOccupier[" + i + "].lockInPeriod"}
                        value={this.state.lockInPeriodOccupier[i].lockInPeriod}
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.lockInPeriodOccupier[id].lockInPeriod =
                            e.target.value;
                          this.calculateOccupierLockInEndDate(values);
                          this.changeLockInPeriodOccupier(values, id);
                          handleChange(e);
                        }}
                      >
                        <option value="" label="Select" defaultValue />
                        <option
                          value="Lease Commencement Date"
                          label="Lease Commencement Date"
                        />
                        <option
                          value="Rent Commencement Date"
                          label="Rent Commencement Date"
                        />
                        <option value="other" label="Other" />
                      </select>
                    </div>
                  </div>
                  <div className="row mb-4 hhhhhh">
                    <div className="col-sm-2">
                      <Field
                        type="text"
                        param={i}
                        name={"lockInPeriodOccupier[" + i + "].lockInPeriodYY"}
                        value={
                          this.state.lockInPeriodOccupier[i].lockInPeriodYY
                        }
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.lockInPeriodOccupier[id].lockInPeriodYY =
                            e.target.value;
                          this.calculateOccupierLockInEndDate(values);
                          handleChange(e);
                        }}
                        onBlur={(e) => {
                          this.calculateOccupierLockInEndDate(values);
                        }}
                        placeholder="YY"
                        className="centerPlaceHolder"
                      />
                    </div>
                    <div className="col-sm-2">
                      <Field
                        type="text"
                        param={i}
                        name={"lockInPeriodOccupier[" + i + "].lockInPeriodMM"}
                        value={
                          this.state.lockInPeriodOccupier[i].lockInPeriodMM
                        }
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.lockInPeriodOccupier[id].lockInPeriodMM =
                            e.target.value;
                          this.calculateOccupierLockInEndDate(values);
                          handleChange(e);
                        }}
                        onBlur={(e) => {
                          this.calculateOccupierLockInEndDate(values);
                        }}
                        placeholder="MM"
                        className="centerPlaceHolder"
                      />
                    </div>
                    <div className="col-sm-2">
                      <Field
                        type="text"
                        param={i}
                        name={"lockInPeriodOccupier[" + i + "].lockInPeriodDD"}
                        value={
                          this.state.lockInPeriodOccupier[i].lockInPeriodDD
                        }
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.lockInPeriodOccupier[id].lockInPeriodDD =
                            e.target.value;
                          this.calculateOccupierLockInEndDate(values);
                          handleChange(e);
                        }}
                        onBlur={(e) => {
                          this.calculateOccupierLockInEndDate(values);
                        }}
                        placeholder="DD"
                        className="centerPlaceHolder"
                      />
                    </div>
                    <div className="col-sm-8 offset-sm-4">
                      {this.mainFormValidator.message(
                        "Lock In Period For Occupier",
                        this.state.lockInPeriodOccupier[i].lockInPeriod,
                        "required",
                        { className: "text-danger" }
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row tabForm">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lock In From Date (For Occupier){" "}
                      <span className="astrik">*</span>
                    </label>
                    <div className="col-sm-8">
                      <Field
                        type="date"
                        param={i}
                        name={"lockInPeriodOccupier[" + i + "].lockInFromDate"}
                        value={
                          this.state.lockInPeriodOccupier[i].lockInFromDate
                        }
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.lockInPeriodOccupier[id].lockInFromDate =
                            e.target.value;
                          handleChange(e);
                        }}
                      />
                      {this.mainFormValidator.message(
                        "Lock In From Date For Occupier",
                        this.state.lockInPeriodOccupier[i].lockInFromDate,
                        "required",
                        { className: "text-danger" }
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Lock In End Date (For Occupier){" "}
                      <span className="astrik">*</span>
                    </label>
                    <div className="col-sm-7">
                      <Field
                        type="date"
                        param={i}
                        name={"lockInPeriodOccupier[" + i + "].lockInEndDate"}
                        value={this.state.lockInPeriodOccupier[i].lockInEndDate}
                        onChange={(e) => {
                          var id = e.target.getAttribute("param");
                          this.state.lockInPeriodOccupier[id].lockInEndDate =
                            e.target.value;
                          handleChange(e);
                        }}
                      />
                      {this.mainFormValidator.message(
                        "Lock In End Date For Occupier",
                        this.state.lockInPeriodOccupier[i].lockInEndDate,
                        "required",
                        { className: "text-danger" }
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
        </TabPanel>
      );
    }

    return (
      <div>
        <Tabs>
          <div className="row m-0 mb-3 align-items-center border-bottom-class bgWhite">
            <div className="col-10 ps-0">
              <TabList>{heads}</TabList>
            </div>
            <div className="button_group col-2 text-end p-0">
              <button className="update_button"
                type="button"
                onClick={(e) => {
                  // let _occupiers = this.state.lockInPeriodOccupier;
                  // _occupiers.splice([i - 1], 1);
                  this.setState({
                    // lockInPeriodOccupier: _occupiers,
                    lockInPeriodCount: this.state.lockInPeriodCount + 1,
                  });
                }}>
                <FontAwesomeIcon icon={faPlus} /> Add Lock In
              </button>
            </div>
          </div>
          <div>{body}</div>
        </Tabs>
      </div>
    );
  }

  render() {
    if (this.state.redirect == true) {
      let url = this.props.match;

      this.state.redirect = false;
      return (
        <Redirect
          push
          to={"/createlease/rental-details/" + this.props.match.params.id}
        />
      );
    }
    return (
      <div
        className="parentContainer createLease">
        <div>
          <div className="absoluteItemForTopBar">
            <div className="new_breadcrumbs_design">
              <ul className="d-flex align-items-center gap-3 p-0 m-0">
                <li>Create Lease</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>Critical Dates</li>
                <li><FontAwesomeIcon icon={faChevronRight} /></li>
                <li>
                  <a href="#">Lock In & Notice Period</a>
                </li>
              </ul>
            </div>
          </div>

          <Formik
            initialValues={this.state.initialValues}
            enableReinitialize
            onSubmit={(values, actions) => {
              if (!this.mainFormValidator.allValid()) {
                console.log(this.mainFormValidator);
                this.mainFormValidator.showMessages();
                return false;
              }
              console.log(values, "val");
              var self = this;
              axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/create-lease/update-lease-lockin?lease_id=${this.props.match.params.id}`,
                data: values,
              }).then(function (response) {
                if (!response.data.success) {
                  actions.setSubmitting(false);
                  actions.setErrors(response.data);
                } else {
                  self.setState({ messsagePopup: true });
                }
              });
            }}
          >
            {({
              values,

              errors,

              touched,

              handleChange,

              handleBlur,

              handleSubmit,

              isSubmitting,
            }) => (
              <>
                <div className="unitFormContainerNew">
                  <Form autoComplete="off" className="customTabs">
                    <div className="newGridSectionParent">
                      <div className="newGridSectionForFormMain">
                        <div className="newGridSectionInner">
                          <label className="col-form-label">
                            Lock In Applicable For Landlord
                            <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              as={"select"}
                              name={"lockInApplicableForLandlord"}
                              onChange={(e) => {
                                this.showLandlordForm(e);
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="yes" label="Yes" />
                              <option value="no" label="No" />
                            </Field>
                          </div>
                        </div>

                        <div className="newGridSectionInner"></div>

                        {this.state.toggleLandlordForm && (
                          <>
                            <div className="newGridSectionInner">
                              <label className="col-form-label">
                                Lock In Period For Landlord (MM-DD) Effective From
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as={"select"}
                                  name={"lockInPeriodLandlord"}
                                  onChange={(e) => {
                                    this.changeLockInPeriodLandlord(e, values);
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option
                                    value="Lease Commencement Date"
                                    label="Lease Commencement Date"
                                  />
                                  <option
                                    value="Rent Commencement Date"
                                    label="Rent Commencement Date"
                                  />
                                  <option
                                    value="Renewal Commencement Date"
                                    label="Renewal Commencement Date"
                                  />
                                  <option value="other" label="Other" />
                                </Field>
                                {this.mainFormValidator.message(
                                  "Lock In Period For Landlord",
                                  values.lockInPeriodLandlord,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label className="col-form-label">
                                Full Lock In Period
                              </label>
                              <div className="position-relative">
                                <Field
                                  style={{ width: "min-content" }}
                                  type="checkbox"
                                  name="lockPeriod"
                                  value="1"
                                  checked={this.state.fullLockInPeriodFlag}
                                  onClick={(e) => {
                                    const isChecked = e.target.checked;
                                    this.setState({ fullLockInPeriodFlag: isChecked });

                                    if (isChecked) {
                                      values.lockInPeriodLandlordEndDate = this.state.lockinPeriodLandlordEndDate;
                                      this.setState({});
                                      this.getDateDiff(values.lockInPeriodLandlordStartDate);
                                    } else {
                                      this.setState({
                                        lockInPeriodLandlordYY: "",
                                        lockInPeriodLandlordMM: "",
                                        lockInPeriodLandlordDD: "",
                                      });

                                      values.lockInPeriodLandlordEndDate = "";
                                    }
                                    handleChange(e);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="newGridSectionInner">
                              <label className="col-form-label">

                              </label>
                              <div className="position-relative">
                                <div className="row m-0">
                                  <div className="col-sm-4 p-0">
                                    <Field
                                      type="text"
                                      name="lockInPeriodLandlordYY"
                                      placeholder="YY"
                                      className="centerPlaceHolder"
                                      value={this.state.lockInPeriodLandlordYY}
                                      onChange={(e) => {
                                        this.state.lockInPeriodLandlordYY =
                                          e.target.value;

                                        this.calculateLockInEndDate(e, values);
                                        handleChange(e);
                                      }}
                                      onBlur={(e) => {
                                        this.calculateLockInEndDate(e, values);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-4">
                                    <Field
                                      type="text"
                                      name="lockInPeriodLandlordMM"
                                      placeholder="MM"
                                      className="centerPlaceHolder"
                                      value={this.state.lockInPeriodLandlordMM}
                                      onChange={(e) => {
                                        this.state.lockInPeriodLandlordMM =
                                          e.target.value;

                                        this.calculateLockInEndDate(e, values);
                                        handleChange(e);
                                      }}
                                      onBlur={(e) => {
                                        this.calculateLockInEndDate(e, values);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-4 p-0">
                                    <Field
                                      type="text"
                                      name="lockInPeriodLandlordDD"
                                      placeholder="DD"
                                      className="centerPlaceHolder"
                                      value={this.state.lockInPeriodLandlordDD}
                                      onChange={(e) => {
                                        this.state.lockInPeriodLandlordDD =
                                          e.target.value;

                                        this.calculateLockInEndDate(e, values);
                                        handleChange(e);
                                      }}
                                      onBlur={(e) => {
                                        this.calculateLockInEndDate(e, values);
                                      }}
                                    />
                                  </div>
                                </div>
                                {this.mainFormValidator.message(
                                  "Lock In Period For Landlord",
                                  values.lockInPeriodLandlord,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner"></div>

                            <div className="newGridSectionInner">
                              <label className="col-form-label">
                                Lock In Period Landlord Start Date
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="lockInPeriodLandlordStartDate"
                                />
                                {this.mainFormValidator.message(
                                  "Lock In Period Landlord Start Date",
                                  values.lockInPeriodLandlordStartDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label className="col-form-label">
                                Lock In Period Landlord End Date
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="date"
                                  name="lockInPeriodLandlordEndDate"
                                />
                                {this.mainFormValidator.message(
                                  "Lock In Period Landlord End Date",
                                  values.lockInPeriodLandlordEndDate,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>
                          </>
                        )}

                        <div className="gridColOneByThree textWithHrTag">
                          <hr className="m-0 my-4" />
                        </div>

                        <div className="newGridSectionInner">
                          <label className="col-form-label">
                            Lock In Applicable For Occupier
                            <span className="astrik">*</span>
                          </label>
                          <div className="position-relative">
                            <Field
                              as={"select"}
                              name={"lockInApplicableForOccupier"}
                              onChange={(e) => {
                                this.showOccupierForm(e);
                                handleChange(e);
                              }}
                            >
                              <option value="" label="Select" defaultValue />
                              <option value="yes" label="Yes" />
                              <option value="no" label="No" />
                            </Field>
                          </div>
                        </div>

                        {this.state.toggleOccupierForm && (
                          <div className="newGridSectionInner">
                            <label className="col-form-label">
                              Count of Lock In Period (For Occupier){" "}
                              <span className="astrik">*</span>
                            </label>
                            <div className="position-relative">
                              <Field
                                className="disable"
                                type="text"
                                name="lockInPeriodCount"
                                value={this.state.lockInPeriodCount}
                                onChange={(e) => {
                                  if (!isNaN(e.target.value)) {
                                    this.setState({
                                      lockInPeriodCount: e.target.value,
                                    });
                                  }
                                }}
                              />
                              <ErrorMessage
                                name="lockInPeriodCount"
                                component="div"
                                className="text-red"
                              />
                            </div>
                          </div>
                        )}
                        <div className="gridColOneByThree">
                          {this.state.toggleOccupierForm &&
                            this.lockInPeriodTabs(handleChange, values)}
                        </div>


                        {(this.state.toggleLandlordForm || this.state.toggleOccupierForm) && (
                          <>
                            <div className="gridColOneByThree textWithHrTag">
                              <hr className="m-0" />
                            </div>
                            <div className="newGridSectionInner">
                              <label>
                                Termination Notice Period (MM-DD){" "}
                                <span className="astrik">*</span>
                              </label>
                              <div className="row m-0">
                                <div className="col-sm-6 ps-0">
                                  <div className="position-relative">
                                    <Field
                                      type="text"
                                      name="terminationNoticePeriodMM"
                                      placeholder="MM"
                                      className="centerPlaceHolder"
                                      value={this.state.terminationNoticePeriodMM}
                                      onChange={(e) => {
                                        this.setState({ terminationNoticePeriodMM: e.target.value });
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-sm-6 pe-0">
                                  <div className="position-relative">
                                    <Field
                                      type="text"
                                      name="terminationNoticePeriodDD"
                                      placeholder="DD"
                                      className="centerPlaceHolder"
                                      value={this.state.terminationNoticePeriodDD}
                                      onChange={(e) => {
                                        this.setState({ terminationNoticePeriodDD: e.target.value });
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                              {this.mainFormValidator.message(
                                "Termination Notice Period (MM-DD)",
                                values.terminationNoticePeriodMM,
                                "required",
                                { className: "text-danger" }
                              )}
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Termination Notice Period (Logic)
                                <span className="astrik">*</span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  as={"select"}
                                  name={"terminationNoticePeriodLogic"}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                >
                                  <option value="" label="Select" defaultValue />
                                  <option
                                    value="Included in LockIn Period"
                                    label="Included in LockIn Period"
                                  />
                                  <option
                                    value="Excluded in LockIn Period"
                                    label="Excluded in LockIn Period"
                                  />
                                </Field>
                                {this.mainFormValidator.message(
                                  "Termination Notice Period Logic",
                                  values.terminationNoticePeriodLogic,
                                  "required",
                                  { className: "text-danger" }
                                )}
                              </div>
                            </div>

                            <div className="newGridSectionInner">
                              <label>
                                Termination Clause
                                <span className="astrik"></span>
                              </label>
                              <div className="position-relative">
                                <Field
                                  type="text"
                                  name={"terminationClause"}
                                />
                              </div>
                            </div>

                          </>
                        )}

                        <div className="gridColOneByThree">
                          <label>Notes/Remarks</label>
                          <Field as="textarea" className="my-2" name="notes_4" />
                        </div>

                      </div>
                      <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                        <button
                          type="submit"
                          className="add_button"
                        >
                          Save Draft
                        </button>
                        <button type="reset" className="reset_button">
                          <Link to="/createlease">
                            Cancel
                          </Link>
                        </button>
                      </div>
                    </div>
                  </Form>
                </div>

                {/* <Form className="customTabs">
                  <div className="unitFormContainer leaseSection lockInSection">
                    <div className="container">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Lock In Applicable For Landlord
                                <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-8">
                                <Field
                                  as={"select"}
                                  name={"lockInApplicableForLandlord"}
                                  onChange={(e) => {
                                    this.showLandlordForm(e);
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="yes" label="Yes" />
                                  <option value="no" label="No" />
                                </Field>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.toggleLandlordForm && (
                        <div className="row">
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row">
                                <label className="col-sm-4 col-form-label">
                                  Lock In Period For Landlord (MM-DD) Effective
                                  From
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-8 ">
                                  <Field
                                    as={"select"}
                                    name={"lockInPeriodLandlord"}
                                    onChange={(e) => {
                                      this.changeLockInPeriodLandlord(
                                        e,
                                        values
                                      );
                                      handleChange(e);
                                    }}
                                  >
                                    <option
                                      value=""
                                      label="Select"
                                      defaultValue
                                    />
                                    <option
                                      value="Lease Commencement Date"
                                      label="Lease Commencement Date"
                                    />
                                    <option
                                      value="Rent Commencement Date"
                                      label="Rent Commencement Date"
                                    />
                                    <option value="other" label="Other" />
                                  </Field>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-4">
                                  <label className="col-sm-6 col-form-label">
                                    Full Lock In Period
                                  </label>
                                </div>
                                <div className="col-sm-1 ">
                                  <Field
                                    type="checkbox"
                                    name="lockPeriod"
                                    value="1"
                                    checked={this.state.fullLockInPeriodFlag}
                                    onClick={(e) => {
                                      const isChecked = e.target.checked;
                                      this.setState({ fullLockInPeriodFlag: isChecked });

                                      if (isChecked) {
                                        values.lockInPeriodLandlordEndDate = this.state.lockinPeriodLandlordEndDate;
                                        this.setState({});
                                        this.getDateDiff(values.lockInPeriodLandlordStartDate);
                                      } else {
                                        this.setState({
                                          lockInPeriodLandlordYY: '',
                                          lockInPeriodLandlordMM: '',
                                          lockInPeriodLandlordDD: ''
                                        });

                                        values.lockInPeriodLandlordEndDate = '';
                                      }
                                      handleChange(e);
                                    }}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-sm-4"></div>
                                <div className="col-sm-2 ">
                                  <Field
                                    type="text"
                                    name="lockInPeriodLandlordYY"
                                    placeholder="YY"
                                    className="centerPlaceHolder"
                                    value={this.state.lockInPeriodLandlordYY}
                                    onChange={(e) => {
                                      this.state.lockInPeriodLandlordYY =
                                        e.target.value;

                                      this.calculateLockInEndDate(e, values);
                                      handleChange(e);
                                    }}
                                    onBlur={(e) => {
                                      this.calculateLockInEndDate(e, values);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-2 ">
                                  <Field
                                    type="text"
                                    name="lockInPeriodLandlordMM"
                                    placeholder="MM"
                                    className="centerPlaceHolder"
                                    value={this.state.lockInPeriodLandlordMM}
                                    onChange={(e) => {
                                      this.state.lockInPeriodLandlordMM =
                                        e.target.value;

                                      this.calculateLockInEndDate(e, values);
                                      handleChange(e);
                                    }}
                                    onBlur={(e) => {
                                      this.calculateLockInEndDate(e, values);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-2 ">
                                  <Field
                                    type="text"
                                    name="lockInPeriodLandlordDD"
                                    placeholder="DD"
                                    className="centerPlaceHolder"
                                    value={this.state.lockInPeriodLandlordDD}
                                    onChange={(e) => {
                                      this.state.lockInPeriodLandlordDD =
                                        e.target.value;

                                      this.calculateLockInEndDate(e, values);
                                      handleChange(e);
                                    }}
                                    onBlur={(e) => {
                                      this.calculateLockInEndDate(e, values);
                                    }}
                                  />
                                </div>
                                <div className="col-sm-8 offset-sm-4">
                                  {this.mainFormValidator.message(
                                    "Lock In Period For Landlord",
                                    values.lockInPeriodLandlord,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Lock In Period Landlord Start Date{" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-8">
                                  <Field
                                    type="date"
                                    name="lockInPeriodLandlordStartDate"
                                  // value={
                                  //   this.state.lockInPeriodLandlordStartDate
                                  // }
                                  />
                                  {this.mainFormValidator.message(
                                    "Lock In Period Landlord Start Date",
                                    values.lockInPeriodLandlordStartDate,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Lock In Period Landlord End Date{" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-7">
                                  <Field
                                    type="date"
                                    name="lockInPeriodLandlordEndDate"
                                  />
                                  {this.mainFormValidator.message(
                                    "Lock In Period Landlord End Date",
                                    values.lockInPeriodLandlordEndDate,
                                    "required",
                                    { className: "text-danger" }
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="row occupierTabMargin">
                        <div className="col-lg-6">
                          <div className="inputContainer col-lg-12 col-md-12">
                            <div className="row mb-3">
                              <label className="col-sm-4 col-form-label">
                                Lock In Applicable For Occupier
                                <span className="astrik">*</span>
                              </label>
                              <div className="col-sm-8">
                                <Field
                                  as={"select"}
                                  name={"lockInApplicableForOccupier"}
                                  onChange={(e) => {
                                    this.showOccupierForm(e);
                                    handleChange(e);
                                  }}
                                >
                                  <option
                                    value=""
                                    label="Select"
                                    defaultValue
                                  />
                                  <option value="yes" label="Yes" />
                                  <option value="no" label="No" />
                                </Field>
                              </div>
                            </div>
                          </div>
                        </div>
                        {this.state.toggleOccupierForm && (
                          <div className="col-lg-6">
                            <div className="inputContainer col-lg-12 col-md-12">
                              <div className="row mb-3">
                                <label className="col-sm-4 col-form-label">
                                  Count of Lock In Period (For Occupier){" "}
                                  <span className="astrik">*</span>
                                </label>
                                <div className="col-sm-8">
                                  <Field
                                    type="text"
                                    name="lockInPeriodCount"
                                    value={this.state.lockInPeriodCount}
                                    onChange={(e) => {
                                      if (!isNaN(e.target.value)) {
                                        this.setState({
                                          lockInPeriodCount: e.target.value,
                                        });
                                      }
                                    }}
                                  />
                                  <ErrorMessage
                                    name="lockInPeriodCount"
                                    component="div"
                                    className="text-red"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  {this.state.toggleOccupierForm &&
                    this.lockInPeriodTabs(handleChange, values)}
                  {(this.state.toggleLandlordForm ||
                    this.state.toggleOccupierForm) && (
                      <div className="unitFormContainer termination">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Termination Notice Period (MM-DD){" "}
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-3">
                                    <Field
                                      type="text"
                                      name="terminationNoticePeriodMM"
                                      placeholder="MM"
                                      className="centerPlaceHolder"
                                      value={this.state.terminationNoticePeriodMM}
                                      onChange={(e) => {
                                        this.state.terminationNoticePeriodMM =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-3">
                                    <Field
                                      type="text"
                                      name="terminationNoticePeriodDD"
                                      placeholder="DD"
                                      className="centerPlaceHolder"
                                      value={this.state.terminationNoticePeriodDD}
                                      onChange={(e) => {
                                        this.state.terminationNoticePeriodDD =
                                          e.target.value;
                                        handleChange(e);
                                      }}
                                    />
                                  </div>
                                  <div className="col-sm-1"></div>
                                  <div className="col-sm-6 offset-sm-4">
                                    {this.mainFormValidator.message(
                                      "Termination Notice Period (MM-DD)",
                                      values.terminationNoticePeriodMM,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Termination Notice Period (Logic)
                                    <span className="astrik">*</span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      as={"select"}
                                      name={"terminationNoticePeriodLogic"}
                                      onChange={(e) => {
                                        handleChange(e);
                                      }}
                                    >
                                      <option
                                        value=""
                                        label="Select"
                                        defaultValue
                                      />
                                      <option
                                        value="Included in LockIn Period"
                                        label="Included in LockIn Period"
                                      />
                                      <option
                                        value="Excluded in LockIn Period"
                                        label="Excluded in LockIn Period"
                                      />
                                    </Field>
                                    {this.mainFormValidator.message(
                                      "Termination Notice Period Logic",
                                      values.terminationNoticePeriodLogic,
                                      "required",
                                      { className: "text-danger" }
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="inputContainer col-lg-12 col-md-12">
                                <div className="row mb-3">
                                  <label className="col-sm-4 col-form-label">
                                    Termination Clause
                                    <span className="astrik"></span>
                                  </label>
                                  <div className="col-sm-7">
                                    <Field
                                      type="text"
                                      name={"terminationClause"}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  <span className="remarks">Notes/Remarks</span>
                  <Field as="textarea" className="notes" name="notes_4" />
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6 offset-lg-6">
                        <div className="btnContainer formSubmit">
                          <div>
                            <button type="submit">
                              Save Draft
                            </button>
                            <button type="submit">
                              <Link to="/createlease">
                                Cancel
                              </Link>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form> */}
              </>
            )}
          </Formik>
        </div>
        <PopupMessage
          open={this.state.messsagePopup}
          content={this.state.popupContent}
          redirectAfterSave={this.redirectAfterSave}
        />
      </div>
    );
  }
}

export default withRouter(LockInNoticePeriod);
